const Department = {
  Default: 'default',
  Luxury: 'luxury',
  UK: 'uk',
  EatingDisorders: 'eatingDisorders',
  SoberLiving: 'soberLiving',
  MentalHealth: 'mentalHealth',
  Providers: 'providers'
}

const computeDepartment = ({ location, term, center }) => {
  if (center?.amenities?.includes('Luxury') || term?.slug === 'luxury') {
    return Department.Luxury
  }

  const hasUKLocation =
    location &&
    Array.isArray(location) &&
    location.some((loc) => loc === 'United Kingdom')
  if (hasUKLocation) {
    return Department.UK
  }

  const isEatingDisorders =
    (center && center.primaryFocus === 'Eating Disorders') ||
    (term && term.slug === 'eating-disorders')
  if (isEatingDisorders) {
    return Department.EatingDisorders
  }

  const isSoberLiving =
    (center &&
      Array.isArray(center.specializations) &&
      center.specializations.includes('Sober Living')) ||
    (term && term.slug === 'sober-living')
  if (isSoberLiving) {
    return Department.SoberLiving
  }

  return Department.Default
}

const getCenterPageDepartment = ({ location, center }) => {
  return computeDepartment({ location, center, term: undefined })
}

const getTaxonomyPageDepartment = ({ term }) => {
  return computeDepartment({ location: undefined, center: undefined, term })
}

const getFacetPageDepartment = ({ locationData, term }) => {
  return computeDepartment({
    location: [
      ...(locationData?.address_parts ?? []).map((part) => part.title),
      locationData?.title
    ],
    center: undefined,
    term
  })
}

const getLocationPageDepartment = ({ locationData }) => {
  return computeDepartment({
    location: [
      ...(locationData?.address_parts ?? []).map((part) => part.title),
      locationData?.title
    ],
    center: undefined,
    term: undefined
  })
}

const getBlogPostPageDepartment = ({ slug }) => {
  if (slug === 'how-to-deal-with-depression') {
    return Department.MentalHealth
  }
  if (slug === 'what-causes-depression') {
    return Department.MentalHealth
  }
  return Department.Default
}

const getDepartmentFooter = ({ departments, department }) => {
  if (!departments || !Array.isArray(departments)) {
    return null
  }
  const requestedDepartment = departments.find(
    (item) => item.title === department
  )

  if (
    requestedDepartment?.footer &&
    Array.isArray(requestedDepartment.footer) &&
    requestedDepartment.footer.length > 0
  ) {
    return requestedDepartment.footer
  }

  // Fall back to default department's footer
  const defaultDepartment = departments.find(
    (item) => item.title === Department.Default
  )

  return defaultDepartment?.footer || null
}

const getDepartmentText = ({ textValues = {}, department }) => {
  const defaultTextValues = textValues[Department.Default] || {}
  const departmentTextValues = textValues[department] || {}

  return {
    ...defaultTextValues,
    ...departmentTextValues
  }
}

module.exports = {
  getCenterPageDepartment,
  getTaxonomyPageDepartment,
  getFacetPageDepartment,
  getLocationPageDepartment,
  getBlogPostPageDepartment,
  computeDepartment,
  getDepartmentFooter,
  getDepartmentText,
  Department
}
